import http from '@/services/rest/rest.service';
import { IPaging } from '@/entities/paging.interface';
import { ISearchBody } from '@/entities/search-body.interface';
import { IAgentListItem } from '@/entities/agents/agent-list-item.interface';
import { IAgentDetail } from '@/entities/agents/agent-detail.interface';
import { IAgentEdit } from '@/entities/agents/agent-edit.interface';
import { IUpdateStatus } from '@/entities/update-status.interface';

export default {
    list(body: ISearchBody): Promise<IPaging<IAgentListItem>> {
        return http.post('agents/search', body);
    },
    get(id: number): Promise<IAgentDetail> {
        return http.get(`agents/${id}`);
    },
    create(model: IAgentEdit): Promise<number> {
        return http.put(`agents`, model);
    },
    update(id: number, model: IAgentEdit): Promise<number> {
        return http.post(`agents/${id}`, model);
    },
    updateStatusBatch(ids: number[], model: IUpdateStatus): Promise<void> {
        return http.post(`agents/status`, { ids, ...model });
    },
    delete(id: number): Promise<void> {
        return http.delete(`agents/${id}`);
    }
};
